
import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ChartDto } from './ChartDto';

@Component({
  selector: 'shared-chart-component',
  templateUrl: './shared.chart.component.html',
  styleUrls: ['./canvas.scss']
})
export class SharedChartComponent {

  public _value: ChartDto;
  @Input() set value(value: ChartDto) {
    if (this._value === value)
      return;
    this._value = value;
  }
  get value(): ChartDto {
    return this._value;
  }

  @Input() public showSelectedLabel: boolean;

  public isSomething(): boolean {
    if (!this._value || !this._value.chartType || this._value.chartType == "")
      return false;
    return true;
  }

  public isData(): boolean {
    if (!this.isSomething())
      return false;

    if (this._value.chartType == ChartDto.PIE && this._value.data != null && this.value.data.length != 0)
      return true;

    return false;

  }

  public isDataSets(): boolean {
    if (!this.isSomething())
      return false;

    if ((this._value.chartType == ChartDto.LINE || this._value.chartType == ChartDto.BAR) && this._value.datasets != null)
      return true;

    return false;

  }

  public selectedlabel: string;
  private _selectedIndex: number;
  @Input() public set selectedIndex(value: number) {
    if (this._selectedIndex === value)
      return;

    this._selectedIndex = value;
    this.setPointsColor(this._selectedIndex);
  }
  public get selectedIndex(): number {
    return this._selectedIndex;
  }

  private lastIndex: number = -1;
  @Output() ChartClick: EventEmitter<any> = new EventEmitter<any>();
  onChartClick($event) {
    if ($event != null) {
      if ($event.active != null) {
        if ($event.active[0] != null) {
          if ($event.active[0]._index != null) {
            this.selectedIndex = $event.active[0]._index;
          }
        }
      }
    }
    this.ChartClick.next($event);
  }

  setPointsColor(index: number) {

    if (this.value != null && this.value.labels != null) {
      if (index == null)
        this.selectedlabel = "";
      else
        this.selectedlabel = this.value.labels[index];

    }
  }


  public pretty(value: any): string {
    return JSON.stringify(value);

  }

}
